import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api'

export const SET_SOLD_TRANSACTIONS = 'Transaction: Sets sold transactions'
export const SET_TRANSACTION_ERROR = 'Transaction: Sets transactions error'
export const SET_PURCHASED_TRANSACTIONS = 'Transaction: Sets purchased transactions'
export const SET_TRANSACTIONS_IS_LOADING = 'Transaction: Sets transactions is loading'

export const setSoldTransactions = createAction(SET_SOLD_TRANSACTIONS)
export const setTransactionsError = createAction(SET_TRANSACTION_ERROR)
export const setPurchasedTransactions = createAction(SET_PURCHASED_TRANSACTIONS)
export const setTransactionsIsLoading = createAction(SET_TRANSACTIONS_IS_LOADING)

const callBtnUrl = (url) => async (dispatch) => {
  try {
    return await dispatch(api.fetch(url))
  } catch (error) {
    return 'error'
  }
}

const fetchSoldTransactions = () => async (dispatch, getState) => {
  dispatch(setTransactionsError(null))
  if (getState().transactions.soldReceipts || !getState().account.user.loggedIn) {
    return
  }
  dispatch(setTransactionsIsLoading(true))
  try {
    const soldTransactions = await dispatch(api.fetch('receipt-be/v1/sold'))
    dispatch(setSoldTransactions(soldTransactions))
  } catch (error) {
    dispatch(setTransactionsError('error'))
  } finally {
    dispatch(setTransactionsIsLoading(false))
  }
}

const fetchPurchasedTransactions = () => async (dispatch, getState) => {
  dispatch(setTransactionsError(null))
  if (getState().transactions.purchasedReceipts || !getState().account.user.loggedIn) {
    return
  }
  dispatch(setTransactionsIsLoading(true))
  try {
    const purchasedTransactions = await dispatch(api.fetch('receipt-be/v1/bought'))
    dispatch(setPurchasedTransactions(purchasedTransactions))
  } catch (error) {
    dispatch(setTransactionsError('error'))
  } finally {
    dispatch(setTransactionsIsLoading(false))
  }
}

export const actionCreators = {
  callBtnUrl,
  fetchSoldTransactions,
  fetchPurchasedTransactions,
  setTransactionsIsLoading,
  setTransactionsError,
}
